module.exports = __webpack_public_path__ + "img/as.c7a6bb4e.svg";